/**
 * @category Response
 */
var ApiResponse = /** @class */ (function () {
    function ApiResponse() {
        ///////////////
        // CONSTANTS //
        ///////////////
        // <editor-fold desc="">
        // </editor-fold>
        ////////////////
        // PROPERTIES //
        ////////////////
        // <editor-fold desc="">
        /**
         * Original HTTP method
         */
        this.method = "";
        /**
         * Request URL
         */
        this.url = "";
        /**
         * Status number
         */
        this.status = 0;
        // </editor-fold>
        /////////////////
        // CONSTRUCTOR //
        /////////////////
        // <editor-fold desc="">
        // </editor-fold>
        /////////////
        // METHODS //
        /////////////
        // <editor-fold desc="">
        // </editor-fold>
    }
    return ApiResponse;
}());
export { ApiResponse };
